<template>
  <MglGeojsonLayer
    :source-id="source.id"
    :source="source.json"
    :layer-id="layer.id"
    :layer="layer.json"
  />
</template>

<script>
import axios from 'axios'
import Mapbox from 'mapbox-gl'
import { MglGeojsonLayer } from 'vue-mapbox'

export default {
  name: 'FinishLineLayer',
  inject: ['mapbox', 'map', 'actions'],
  components: {
    MglGeojsonLayer
  },
  props: {
    raceId: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      layer: {
        id: 'finish-line',
        json: {
          'type': 'line',
          'source': 'finish-line-source',
          'layout': {
            'line-join': 'round',
            'line-cap': 'round'
          },
          'paint': {
            'line-color': '#FF0000',
            'line-width': 1
          }
        }
      }
    }
  },
  computed: {
    source () {
      var coords = [[153.4426666667, -27.97], [153.44, -27.9706666667]]

      /* startline 33 51.6S, 151 14.4E and 33 51.8S, 151 15.1E */

      /* finishline 27 58.20 S, 153 26.56 E and 27 58.24 S, 153 26.40 E */

      return {
        id: 'finish-line-source',
        json: {
          'type': 'geojson',
          'data': {
            'type': 'Feature',
            'properties': {},
            'geometry': {
              'type': 'LineString',
              'coordinates': coords
            }
          },
          'cluster': false
        }
      }
    }
  }
}
</script>